module.exports = __webpack_public_path__ + "static/media/logo-janauba.b5434ed2.png";